import { ProjectRoles, ProjectResponsible } from '../../models/project';

export const getProjectResponsiblesMapByKey = (
  responsibleList: ProjectResponsible[] = [],
): Record<string, string | undefined> => {
  return Object.entries(ProjectRoles).reduce(
    (acc, [key, value]) => {
      const found = responsibleList.find(
        (item) => item.projectResponsibleRole === key,
      );
      if (found) {
        acc[value] = found.projectResponsiblePerson;
      }
      return acc;
    },
    {} as Record<string, string | undefined>,
  );
};
